const BASE_API =  process.env.VUE_APP_API_HOST
export const BASE_URL = BASE_API + "/v1/api/"
export const BASE_ECHO_URL = "//" + BASE_API
export const SOCKET_PORT = process.env.VUE_APP_LARAVEL_ECHO_PORT